import { SpanProcessor, Span } from '@opentelemetry/sdk-trace-base';
import { Context } from '@opentelemetry/api';

export class HttpSpanNameProcessor implements SpanProcessor {
  private baseUrl = window.location.origin + '/' || '';
  onStart(span: Span, parentContext: Context): void {
    // Only modify HTTP spans
    const method = span.attributes['http.method'];
    const url = (span.attributes['http.url'] || span.attributes['http.uri'])?.toString().replace(this.baseUrl, '');
    if (method && url) {
      span.updateName(`${method} ${url}`);
    }
  }
  onEnd(span: Span): void {}
  shutdown(): Promise<void> { return Promise.resolve(); }
  forceFlush(): Promise<void> { return Promise.resolve(); }
}
